import { Box } from "@mui/material"
import AppBar from "common/components/appBar"
import NavigationSidebar from "common/components/navigationSidebar"
import * as React from "react"
import * as styles from "./layout.styles"

type Props = {
    children: React.ReactNode
}
/**
 * Layout component to provide app-level layout
 * Referenced from https://nextjs.org/docs/basic-features/layouts
 */
const Layout = (props: Props) => {
    return (
        <Box css={styles.layout}>
            <Box css={styles.appBar}>
                <AppBar />
            </Box>
            <Box>
                <Box css={styles.sidebar}>
                    <NavigationSidebar />
                </Box>
                <Box css={styles.content}>{props.children}</Box>
            </Box>
        </Box>
    )
}

export default Layout
